import React, { createContext, useState, useContext, useEffect } from 'react';
import { getUser, setUser as saveUser, removeUser } from '../utils/auth';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const storedUser = getUser();
    if (storedUser) {
      try {
        const response = await api.get('/auth/me');
        setUser(response.data);
        saveUser(response.data);
      } catch (error) {
        removeUser();
        setUser(null);
      }
    }
    setLoading(false);
  };

  const login = (userData) => {
    setUser(userData);
    saveUser(userData);
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setUser(null);
      removeUser();
    }
  };

  const value = {
    user,
    login,
    logout,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};